import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { Observable, of } from 'rxjs';
import { catchError, filter, first } from 'rxjs/operators';


export interface SubscribeNewsletter {
  newsletter?: string;
  createdAt?: string;
}

@Injectable()
export class SubscribeNewsletterService {

  private store?: {
    id: string;
    appId: number;
    languageId: string;
  };

  constructor(
    private readonly http: HttpClient,
    private readonly contextService: ContextService
  ) {
    this.contextService.getContext$()
      .pipe(
        filter((context: EcommerceContext) => !!context && !!context.store && !!context.config),
        first()
      )
      .subscribe((context: EcommerceContext) => {
        this.store = {
          id: context.store.id,
          languageId: context.currentLanguage.id,
          appId: context.config.appId
        };
      });
  }

  public search(country: string, lang: string, accessToken?: string): Observable<SubscribeNewsletter> {
    const options = accessToken ? { headers: new HttpHeaders({ Authorization: `Bearer ${accessToken}` }) } : {};
    const path = window.location.hostname.startsWith('www.stradivarius.com') || window.location.hostname.startsWith('axinstgeccwps1-stradivarius.central.inditex.grp') ? 'https://www.stradivarius.com' : 'https://preint-stradivariuscom.inditex.com';
    return this.http.get<SubscribeNewsletter>(`${path}/itxrest/2/user/store/${this.store?.id}/newsletter?languageId=${this.store?.languageId}&locale=${lang}_${country}&appId=${this.store?.appId}`, options).pipe(
      catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
    );
  }

}
